export default "__VITE_ASSET__CZeLnF9A__"